<div class="header" translate="{{ confirmDialogMessageTranslationKey }}"></div>
<div class="footer">
  <ion-button (click)="ok('ok')" class="native">
    {{ 'm/ok' | translate }}
  </ion-button>
  <ion-button fill="outline" (click)="cancel()">
    {{ 'm/cancel' | translate }}
  </ion-button>
</div>
